import React from 'react';
import { Button, Icon } from 'react-inv-forms';
import { Tooltip } from 'antd';

import { ActionsElements } from './TableActionButtons.style';
import pen from '../../../../images/penRed.svg';
import penGrey from '../../../../images/penGrey.svg';
import success from '../../../../images/success.png';
import trash from '../../../../images/trash.png';
import close from '../../../../images/close.svg';
import { useTranslation } from 'react-i18next';
export interface Props {
  /** informacja, czy rekord znajduje się w trybie edycji */
  editable: boolean;
  /** callback wykonywany po kliknięciu na przycisk "Zatwierdź" (ikona ptaszka) */
  onChangeConfirmation?: () => void;
  /** callback wykonywany po kliknięciu na przycisk "Anuluj" (ikona krzyżyka) */
  onChangeCancel?: () => void;
  /** callback wykonywany po kliknięciu na przycisk "Edytuj" (ikona ołówka) */
  onEdit?: () => void;
  /** callback wykonywany po kliknięciu na przycisk "Usuń" (ikona kosza) */
  onDelete?: () => void;
  /** informacja, czy buttony powinny być dezaktywowane */
  disabled: boolean;
  /* informacja, czy edycja parametru powinna być umożliwiona */
  enableEditing?: boolean;
}
/**
 * Komponent pomocniczy generujący buttony akcji dla tabel w zależności od trybu edycji generuje:
 *  - button włączający tryb edycji oraz usuwający dany rekord, gdy tryb edycji jest wyłączony
 *  - button zatwierdzający wprowadzone zmiany i anulujący je, gdy tryb edycji jest włączony
 *
 */
export const TableActionButtons: React.FunctionComponent<Props> = ({ enableEditing = true, ...props }: Props) => {
  const { t } = useTranslation();

  return (
    <ActionsElements>
      {enableEditing ? (
        props.editable ? (
          <>
            <Button onClick={props.onChangeConfirmation} className='btn_no_hover'>
              <Icon path={success} className='smaller' />
            </Button>
            <Button onClick={props.onChangeCancel} className='btn_no_hover'>
              <Icon path={close} />
            </Button>
          </>
        ) : (
          <>
            {props.onEdit ? (
              <Button disabled={props.disabled} className='btn_no_hover' onClick={props.onEdit}>
                <Icon path={pen} />
              </Button>
            ) : null}
            {props.onDelete ? (
              <Button disabled={props.disabled} className='btn_no_hover' onClick={props.onDelete}>
                <Icon path={trash} className='icon_trash' />
              </Button>
            ) : null}
          </>
        )
      ) : (
        <Tooltip title={t('CANNOT_EDIT_RECORD')}>
          <Button className='btn_no_hover'>
            <Icon path={penGrey} />
          </Button>
        </Tooltip>
      )}
    </ActionsElements>
  );
};
export default TableActionButtons;
